export default "__VITE_ASSET__e8b8ac71__"